import React from 'react';
import { Grid } from '@mui/material';
import InformationField from '../../../sharedModules/form/components/InformationField';

interface ChillerLogHeaderProps {
  chillerJob?: any;
}

const ChillerLogHeader: React.FC<ChillerLogHeaderProps> = (props) => {
  const { chillerJob } = props;

  return (
    <Grid container style={{ marginBottom: 10 }}>
      <Grid item xs={12} md={12}>
        <Grid container spacing={4} justifyContent="spaceBetween">
          <Grid item xs={2}>
            <InformationField label="Schedule" value={chillerJob?.schedule_date_range} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Order" value={chillerJob?.order_no} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Customer" value={chillerJob?.company_name} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Manufacturer" value={chillerJob?.manufacturer_name} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Asset" value={chillerJob?.asset_no} />
          </Grid>
        </Grid>
        <Grid container spacing={4} style={{ marginTop: '-20px' }}>
          <Grid item xs={2}>
            <InformationField label="Model #" value={chillerJob?.model_no} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Serial #" value={chillerJob?.serial_no} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Department" value={chillerJob?.dept_name} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Refrigerant" value={chillerJob?.refg} />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Logging Tech" value={chillerJob?.display_emp_id} />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <InformationField
              label="Condenser Eddy Current"
              value={`Last: ${chillerJob?.condenser_eddy_testing_last_date || 'Unknown'} \nNext: ${chillerJob?.condenser_eddy_testing_next_date || 'Unknown'}`}
            />
          </Grid>
          <Grid item xs={3}>
            <InformationField
              label="Evaporator Eddy Current"
              value={`Last: ${chillerJob?.evaporator_eddy_testing_last_date || 'Unknown'} \nNext: ${chillerJob?.evaporator_eddy_testing_next_date || 'Unknown'}`}
            />
          </Grid>
          <Grid item xs={2}>
            <InformationField label="Oil Analysis" value={`Last: ${chillerJob?.oil_analysis_date || 'Unknown'}`} />
          </Grid>
          <Grid item xs={3}>
            <InformationField
              label="Vibration Analysis"
              value={`Last: ${chillerJob?.vibration_analysis_date || 'Unknown'}`}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChillerLogHeader;
